export default {
  avisos: [],
}
